import { ButtonColor } from "@/common/enum/button-color";
import {
  formatDateToYYYYMMDDhhmm,
  isWithinOneWeek,
} from "@/common/util/date-util";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit"; // 필요한 Tiptap 확장 모듈
import { useEffect } from "react";
import { StatusButton } from "../button/StatusButton";
import { Divider } from "../devider/Devider";
import { Body14Regular } from "../typography/Body14Regular";
import { H5 } from "../typography/H5";

interface Props {
  selectedNotice: NoticeDetailDto;
}

export const PartnerNoticeDetailPanel: React.FC<Props> = ({
  selectedNotice,
}) => {
  const isNew = isWithinOneWeek(new Date(selectedNotice.createdAt));

  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({
        openOnClick: true,
        autolink: true,
        defaultProtocol: "https",
        HTMLAttributes: {
          class: "custom-link",
        },
      }),
      Underline,
      Image.configure({
        HTMLAttributes: {
          class: "custom-image",
        },
      }),
    ],
    content: selectedNotice.content ? JSON.parse(selectedNotice.content) : {},
    editable: false,
  });

  useEffect(() => {
    if (editor && selectedNotice.content) {
      editor.commands.setContent(JSON.parse(selectedNotice.content));
    }
  }, [editor, selectedNotice.content]);

  return (
    <div className="flex bg-primary-white w-[620px] h-[814px] p-[24px] flex-col rounded-lg border">
      {isNew && (
        <div>
          <StatusButton color={ButtonColor.GREEN}>신규</StatusButton>
        </div>
      )}

      <H5 className="flex items-center justify-between mt-[8px]">
        <H5 className="text-semantic-text-body">{selectedNotice.title}</H5>
        <Body14Regular className="text-semantic-text-secondary">
          {formatDateToYYYYMMDDhhmm(selectedNotice.createdAt)}
        </Body14Regular>
      </H5>
      <div className="my-[24px]">
        <Divider />
      </div>

      <EditorContent editor={editor} />
    </div>
  );
};
